// 默认LUN的CDP计划，每1小时执行一次,每天00:05执行一次,每周日00:10执行一次
export const SIMPLE_CDP_SCHEDULE_SAN_DEFAULT =
{
    NAME: 'SAN_DEFAULT_SIMPLE',
    DAILYSNAPSHOTNUM: '2',
    DAYHOURS: '[0]',
    DAYMINUTE: '5',
    FREQUENCYNUM: '3',
    FREQUENCYVALUE: '3600',
    MONTHDAYS: '[]',
    MONTHSNAPSHOTNUM: '-1',
    SCHEDULETYPE: '1',
    STARTTIMEOFWEEK: '00:10',
    WEEKLYDAYS: '[0]',
    WEEKLYSNAPSHOTNUM: '2',
    OBJECTTYPE: '0',
    SECURESNAPENABLED: 'false',
    vstoreId: '0',
    vstoreName: 'System_vStore',
    TYPE: 57527,
};

// 默认FS的CDP计划，每1小时执行一次,每天00:05执行一次,每周日00:10执行一次
export const SIMPLE_CDP_SCHEDULE_NAS_DEFAULT = {
    NAME: 'NAS_DEFAULT_SIMPLE',
    DAILYSNAPSHOTNUM: '2',
    DAYHOURS: '[0]',
    DAYMINUTE: '5',
    FREQUENCYNUM: '3',
    FREQUENCYVALUE: '3600',
    MONTHDAYS: '[]',
    MONTHSNAPSHOTNUM: '-1',
    SCHEDULETYPE: '1',
    STARTTIMEOFWEEK: '00:10',
    WEEKLYDAYS: '[0]',
    WEEKLYSNAPSHOTNUM: '2',
    OBJECTTYPE: '1',
    WEEKLYSECURESNAPENABLED: false,
    vstoreId: '0',
    vstoreName: 'System_vStore',
    TYPE: 57527,
};
